import i18n from '../../core/services/i18n/i18n'

let channels = []
let isFluid = false
let element = document.getElementById('social-component')

if (!element) {
  element = document.getElementById('social-component--fluid')
  isFluid = true
}

if (element && element.dataset.channels) {
  channels = JSON.parse(element.dataset.channels)
}

export default {
  title: i18n.get('Social.Title'),
  subtitle: i18n.get('Social.Subtitle'),
  channels,
  element,
  isFluid,
}
